/**
 * Traduções completas do site para de, nl, ru, ar, zh-CN, zh-TW.
 * Mesma forma de objeto que `en` em translations.js — apenas dados.
 */

export const siteLocales = {
  de: {
    nav: {
      about: 'Über uns',
      services: 'Leistungen',
      methodology: 'Methodik',
      founder: 'Gründer',
      contact: 'Kontakt'
    },
    hero: {
      title: 'Transformieren Sie Ihr Unternehmen mit',
      titleHighlight: 'Premium-Digitallösungen',
      subtitle:
        'Professionelle Webentwicklung, strategisches Digitalmarketing und intelligente Automatisierung für Unternehmen, die Exzellenz und messbare Ergebnisse anstreben.',
      cta: 'Demo vereinbaren',
      ctaSecondary: 'WhatsApp-Chat'
    },
    about: {
      title: 'Über WSJ Digital Solutions',
      description:
        'Es begann mit der Vision von William Sarti José: Ideen in moderne, elegante digitale Lösungen zu verwandeln, die echte Ergebnisse liefern.',
      description2:
        'WSJ Digital Solutions entwickelt Webplattformen, Automatisierung, E-Commerce, maßgeschneiderte Systeme, intelligente digitale Speisekarten und skalierbare Lösungen für Unternehmen, die im digitalen Umfeld wachsen wollen.\n\nDer Punkt in „WSJ.“ steht für Kontinuität, Evolution und ständige Expansion — eine Marke, die bereit ist, Geschäfte mit Technologie zu transformieren.',
      yearsTitle: 'Jahre Erfahrung',
      clientsTitle: 'Zufriedene Kunden',
      projectsTitle: 'Abgeschlossene Projekte'
    },
    pyramid: {
      title: 'Unsere Methodik: Pyramide des digitalen Erfolgs',
      subtitle: 'Ein strukturierter und bewährter Ansatz, um Ihre digitale Präsenz in konkrete Ergebnisse zu verwandeln',
      level1Title: 'Eigene Website',
      level1Subtitle: 'Professionelle Basis',
      level1Point1: 'Premium-Websites mit modernem Design',
      level1Point2: 'Landingpages mit hoher Conversion',
      level1Point3: 'Erweiterte Integrationen und Automatisierung',
      level1Point4: 'Optimierte Nutzererfahrung',
      level2Title: 'Digitalmarketing',
      level2Subtitle: 'Strategisches Wachstum',
      level2Point1: 'Professionelles Social-Media-Management',
      level2Point2: 'Video- und visuelle Content-Produktion',
      level2Point3: 'ROI-orientierte Werbekampagnen',
      level2Point4: 'Datenanalyse und kontinuierliche Optimierung',
      level3Title: 'IT-Dienstleistungen',
      level3Subtitle: 'Innovation und Skalierbarkeit',
      level3Point1: 'Web- und App-Entwicklung',
      level3Point2: 'Vollständiger E-Commerce und Integrationen',
      level3Point3: 'Prozess- und Systemautomatisierung',
      level3Point4: 'Maßgeschneiderte und skalierbare Lösungen'
    },
    services: {
      title: 'Unsere Leistungen',
      subtitle: 'Komplettlösungen für die digitale Transformation Ihres Unternehmens',
      service1Title: 'Webentwicklung',
      service1Desc:
        'Unternehmenswebsites, Landingpages und professionelle Portale mit Premium-Design und modernster Technologie.',
      service2Title: 'E-Commerce',
      service2Desc:
        'Vollständige Online-Shops, Zahlungsintegrationen und automatisierte Verwaltung zur Maximierung Ihrer Online-Verkäufe.',
      service3Title: 'Digitalmarketing',
      service3Desc:
        'Integrierte Marketingstrategien, Social-Media-Management und werbliche Kampagnen mit Fokus auf Ergebnisse.',
      service4Title: 'Automatisierung',
      service4Desc:
        'Prozesse optimieren, Zeit sparen und Kosten senken mit intelligenter Automatisierung und maßgeschneiderten Integrationen.',
      service5Title: 'Mobile Apps',
      service5Desc:
        'Native und hybride Apps für iOS und Android mit intuitivem Design und hoher Performance.',
      service6Title: 'IT-Beratung',
      service6Desc:
        'Spezialisierte Begleitung bei digitaler Transformation, Systemarchitektur und Technologiestrategie.',
      service7Title: 'Digitale Speisekarte',
      service7Desc:
        'Digitale Speisekarten für Restaurants, Konditoreien, Barbershops, Salons und Termin-Services mit Onlinebestellung, WhatsApp, QR-Code, Zeiten und Paketen.',
      service8Title: 'Stadtverkehr in Echtzeit',
      service8Desc:
        'Intelligente Lösungen zur Überwachung und Visualisierung des Stadtverkehrs in Echtzeit – mit Fokus auf Mobilität, Standort und Nutzererlebnis.',
      cta: 'Alle Leistungen entdecken'
    },
    founder: {
      title: 'Den Gründer kennenlernen',
      name: 'William Sarti José',
      role: 'Gründer & Software Engineer',
      bio:
        'Mit über 10 Jahren Erfahrung in der IT ist William auf Java, React und Künstliche Intelligenz spezialisiert. Zu seiner Laufbahn gehören Lehre in Informatik, Senior-Entwicklung und Leitung komplexer Technologieprojekte.',
      bio2:
        'Mit fundierter akademischer und beruflicher Erfahrung verbindet William technische Tiefe mit strategischer Unternehmenssicht und liefert Lösungen, die für Kunden einen echten Mehrwert schaffen.',
      expertiseTitle: 'Schwerpunkte',
      expertise1: 'Java & Spring Framework',
      expertise2: 'React & Frontend-Entwicklung',
      expertise3: 'Künstliche Intelligenz & Machine Learning',
      expertise4: 'Systemarchitektur',
      expertise5: 'Projektmanagement',
      expertise6: 'Lehre und Mentoring',
      authorityTitle: 'Professionelle Präsenz',
      linkedin: 'LinkedIn',
      lattes: 'Lattes-CV',
      github: 'GitHub-Repository',
      professionalCourse: 'Professioneller Kurs',
      location: 'Braga, Portugal'
    },
    contact: {
      title: 'Bereit für den nächsten Schritt?',
      subtitle: 'Kontaktieren Sie uns und erfahren Sie, wie wir Ihr Unternehmen voranbringen können',
      formTitle: 'Nachricht senden',
      nameLabel: 'Ihr Name',
      namePlaceholder: 'Vollständiger Name',
      emailLabel: 'E-Mail',
      emailPlaceholder: 'ihre@email.com',
      phoneLabel: 'Telefon (optional)',
      phonePlaceholder: '+49 000 00000000',
      messageLabel: 'Nachricht',
      messagePlaceholder: 'Erzählen Sie uns von Ihrem Projekt…',
      submitButton: 'Nachricht senden',
      whatsappTitle: 'Oder direkt per WhatsApp',
      whatsappButton: 'WhatsApp öffnen',
      infoTitle: 'Kontaktdaten',
      phone: 'Telefon',
      email: 'E-Mail',
      locationLabel: 'Standort',
      phonesTitle: 'Telefonleitungen',
      locationsTitle: 'Standorte',
      phoneBrazilLabel: 'Brasilien',
      phonePortugalLabel: 'Portugal',
      phoneBrazilDisplay: '+55 18 99787-4643',
      phonePortugalDisplay: '+351 924 963 314',
      locationBrazil: 'São Paulo, Brasilien',
      locationPortugal: 'Braga, Portugal'
    },
    footer: {
      tagline: 'Ideen in exzellente digitale Lösungen verwandeln',
      servicesTitle: 'Leistungen',
      companyTitle: 'Unternehmen',
      contactTitle: 'Kontakt',
      servicesList: {
        web: 'Webentwicklung',
        ecommerce: 'E-Commerce',
        marketing: 'Digitalmarketing',
        automation: 'Automatisierung',
        mobile: 'Mobile Apps'
      },
      companyList: {
        about: 'Über uns',
        methodology: 'Methodik',
        founder: 'Gründer',
        contact: 'Kontakt'
      },
      copyright: '© 2025 WSJ Digital Solutions. Alle Rechte vorbehalten.',
      followTitle: 'WSJ folgen',
      madeWith: 'Erstellt mit',
      location: 'in Braga, Portugal'
    }
  },

  nl: {
    nav: {
      about: 'Over ons',
      services: 'Diensten',
      methodology: 'Methodologie',
      founder: 'Oprichter',
      contact: 'Contact'
    },
    hero: {
      title: 'Transformeer uw bedrijf met',
      titleHighlight: 'Premium digitale oplossingen',
      subtitle:
        'Professionele webontwikkeling, strategisch digital marketing en intelligente automatisering voor organisaties die excellentie en echte resultaten nastreven.',
      cta: 'Demo plannen',
      ctaSecondary: 'Chat op WhatsApp'
    },
    about: {
      title: 'Over WSJ Digital Solutions',
      description:
        'Het begon met de visie van William Sarti José: ideeën omzetten in moderne, elegante digitale oplossingen met echte impact.',
      description2:
        'WSJ Digital Solutions bouwt webplatforms, automatisering, e-commerce, maatwerksystemen, slimme digitale menukaarten en schaalbare oplossingen voor bedrijven die online willen groeien.\n\nDe punt in “WSJ.” staat voor continuïteit, evolutie en constante groei — een merk klaar om business te transformeren met technologie.',
      yearsTitle: 'Jaar ervaring',
      clientsTitle: 'Tevreden klanten',
      projectsTitle: 'Afgeronde projecten'
    },
    pyramid: {
      title: 'Onze methodiek: piramide van digitaal succes',
      subtitle: 'Een gestructureerde en bewezen aanpak om uw digitale aanwezigheid om te zetten in concrete resultaten',
      level1Title: 'Eigen website',
      level1Subtitle: 'Professionele basis',
      level1Point1: 'Premium zakelijke websites met modern design',
      level1Point2: 'Landingspagina’s met hoge conversie',
      level1Point3: 'Geavanceerde integraties en automatisering',
      level1Point4: 'Geoptimaliseerde gebruikerservaring',
      level2Title: 'Digital marketing',
      level2Subtitle: 'Strategische groei',
      level2Point1: 'Professioneel socialmediabeheer',
      level2Point2: 'Video- en visuele content',
      level2Point3: 'Advertentiecampagnes gericht op ROI',
      level2Point4: 'Data-analyse en continue optimalisatie',
      level3Title: 'IT-diensten',
      level3Subtitle: 'Innovatie en schaalbaarheid',
      level3Point1: 'Web- en app-ontwikkeling',
      level3Point2: 'Volledige e-commerce en integraties',
      level3Point3: 'Proces- en systeemautomatisering',
      level3Point4: 'Op maat gemaakte, schaalbare oplossingen'
    },
    services: {
      title: 'Onze diensten',
      subtitle: 'Complete oplossingen om uw bedrijf digitaal te transformeren',
      service1Title: 'Webontwikkeling',
      service1Desc:
        'Zakelijke websites, landingspagina’s en professionele portals met premium design en moderne technologie.',
      service2Title: 'E-commerce',
      service2Desc:
        'Volledige webwinkels, betalingsintegraties en geautomatiseerd beheer om uw online verkopen te maximaliseren.',
      service3Title: 'Digital marketing',
      service3Desc:
        'Geïntegreerde marketingstrategieën, socialmediabeheer en advertentiecampagnes gericht op resultaat.',
      service4Title: 'Automatisering',
      service4Desc:
        'Optimaliseer processen, bespaar tijd en verlaag kosten met slimme automatisering en maatwerkintegraties.',
      service5Title: 'Mobiele apps',
      service5Desc:
        'Native en hybride apps voor iOS en Android met intuïtief design en uitstekende prestaties.',
      service6Title: 'IT-advies',
      service6Desc:
        'Gespecialiseerde begeleiding bij digitale transformatie, systeemarchitectuur en technologische strategie.',
      service7Title: 'Digitale menukaart',
      service7Desc:
        'Digitale menukaarten voor restaurants, bakkerijen, kappers, salons en afspraakdiensten, met online bestellen, WhatsApp, QR-code, tijden en pakketten.',
      service8Title: 'Stedelijk vervoer in realtime',
      service8Desc:
        'Slimme oplossingen voor monitoring en visualisatie van stedelijk vervoer in realtime, met focus op mobiliteit, locatie en gebruikerservaring.',
      cta: 'Alle diensten bekijken'
    },
    founder: {
      title: 'Maak kennis met de oprichter',
      name: 'William Sarti José',
      role: 'Oprichter & software engineer',
      bio:
        'Met ruim 10 jaar ervaring in IT is William gespecialiseerd in Java, React en kunstmatige intelligentie. Zijn loopbaan omvat onderwijs in informatica, senior ontwikkeling en leiding bij complexe technische projecten.',
      bio2:
        'Met een sterke academische en professionele achtergrond combineert William diepgaande technische kennis met strategisch inzicht en levert oplossingen die echt het verschil maken.',
      expertiseTitle: 'Expertisegebieden',
      expertise1: 'Java & Spring Framework',
      expertise2: 'React & frontend-ontwikkeling',
      expertise3: 'Kunstmatige intelligentie & machine learning',
      expertise4: 'Systeemarchitectuur',
      expertise5: 'Projectmanagement',
      expertise6: 'Onderwijs en mentoring',
      authorityTitle: 'Professioneel profiel',
      linkedin: 'LinkedIn',
      lattes: 'Lattes CV',
      github: 'GitHub-repository',
      professionalCourse: 'Professionele cursus',
      location: 'Braga, Portugal'
    },
    contact: {
      title: 'Klaar om uw bedrijf te transformeren?',
      subtitle: 'Neem contact op en ontdek hoe wij uw organisatie verder helpen',
      formTitle: 'Stuur uw bericht',
      nameLabel: 'Uw naam',
      namePlaceholder: 'Volledige naam',
      emailLabel: 'E-mail',
      emailPlaceholder: 'uw@email.com',
      phoneLabel: 'Telefoon (optioneel)',
      phonePlaceholder: '+31 6 00000000',
      messageLabel: 'Bericht',
      messagePlaceholder: 'Vertel over uw project…',
      submitButton: 'Bericht versturen',
      whatsappTitle: 'Of chat direct via WhatsApp',
      whatsappButton: 'WhatsApp openen',
      infoTitle: 'Contactgegevens',
      phone: 'Telefoon',
      email: 'E-mail',
      locationLabel: 'Locatie',
      phonesTitle: 'Telefoonlijnen',
      locationsTitle: 'Locaties',
      phoneBrazilLabel: 'Brazilië',
      phonePortugalLabel: 'Portugal',
      phoneBrazilDisplay: '+55 18 99787-4643',
      phonePortugalDisplay: '+351 924 963 314',
      locationBrazil: 'São Paulo, Brazilië',
      locationPortugal: 'Braga, Portugal'
    },
    footer: {
      tagline: 'Ideeën omzetten in uitstekende digitale oplossingen',
      servicesTitle: 'Diensten',
      companyTitle: 'Bedrijf',
      contactTitle: 'Contact',
      servicesList: {
        web: 'Webontwikkeling',
        ecommerce: 'E-commerce',
        marketing: 'Digital marketing',
        automation: 'Automatisering',
        mobile: 'Mobiele apps'
      },
      companyList: {
        about: 'Over ons',
        methodology: 'Methodologie',
        founder: 'Oprichter',
        contact: 'Contact'
      },
      copyright: '© 2025 WSJ Digital Solutions. Alle rechten voorbehouden.',
      followTitle: 'Volg WSJ',
      madeWith: 'Gemaakt met',
      location: 'in Braga, Portugal'
    }
  },

  ru: {
    nav: {
      about: 'О нас',
      services: 'Услуги',
      methodology: 'Методология',
      founder: 'Основатель',
      contact: 'Контакты'
    },
    hero: {
      title: 'Трансформируйте бизнес с',
      titleHighlight: 'премиальными цифровыми решениями',
      subtitle:
        'Профессиональная веб-разработка, стратегический digital-маркетинг и интеллектуальная автоматизация для компаний, стремящихся к качеству и измеримым результатам.',
      cta: 'Запланировать демо',
      ctaSecondary: 'Написать в WhatsApp'
    },
    about: {
      title: 'О WSJ Digital Solutions',
      description:
        'Всё началось с видения Уильяма Сарти Жозе: превращать идеи в современные, элегантные цифровые решения, ориентированные на реальный результат.',
      description2:
        'WSJ Digital Solutions создаёт веб-платформы, автоматизацию, e-commerce, индивидуальные системы, умные цифровые меню и масштабируемые продукты для бизнеса, который растёт в цифровой среде.\n\nТочка в «WSJ.» — это непрерывность, эволюция и постоянное расширение: бренд, готовый менять бизнес с помощью технологий.',
      yearsTitle: 'Лет опыта',
      clientsTitle: 'Довольных клиентов',
      projectsTitle: 'Реализованных проектов'
    },
    pyramid: {
      title: 'Наша методология: пирамида цифрового успеха',
      subtitle: 'Структурированный и проверенный подход к превращению вашего цифрового присутствия в конкретные результаты',
      level1Title: 'Собственный сайт',
      level1Subtitle: 'Профессиональный фундамент',
      level1Point1: 'Премиальные корпоративные сайты с современным дизайном',
      level1Point2: 'Лендинги с высокой конверсией',
      level1Point3: 'Продвинутые интеграции и автоматизация',
      level1Point4: 'Оптимизированный пользовательский опыт',
      level2Title: 'Digital-маркетинг',
      level2Subtitle: 'Стратегический рост',
      level2Point1: 'Профессиональное ведение соцсетей',
      level2Point2: 'Видео и визуальный контент',
      level2Point3: 'Рекламные кампании с фокусом на ROI',
      level2Point4: 'Аналитика данных и постоянная оптимизация',
      level3Title: 'IT-услуги',
      level3Subtitle: 'Инновации и масштабируемость',
      level3Point1: 'Разработка веб и мобильных приложений',
      level3Point2: 'Полноценный e-commerce и интеграции',
      level3Point3: 'Автоматизация процессов и систем',
      level3Point4: 'Индивидуальные и масштабируемые решения'
    },
    services: {
      title: 'Наши услуги',
      subtitle: 'Комплексные решения для цифровой трансформации вашего бизнеса',
      service1Title: 'Веб-разработка',
      service1Desc:
        'Корпоративные сайты, лендинги и порталы премиум-класса с современным дизайном и передовыми технологиями.',
      service2Title: 'E-commerce',
      service2Desc:
        'Полноценные интернет-магазины, платёжные интеграции и автоматизированное управление для роста онлайн-продаж.',
      service3Title: 'Digital-маркетинг',
      service3Desc:
        'Интегрированные стратегии, SMM и рекламные кампании с упором на результат.',
      service4Title: 'Автоматизация',
      service4Desc:
        'Оптимизация процессов, экономия времени и снижение затрат за счёт интеллектуальной автоматизации и интеграций.',
      service5Title: 'Мобильные приложения',
      service5Desc:
        'Нативные и гибридные приложения для iOS и Android с интуитивным UX и высокой производительностью.',
      service6Title: 'IT-консалтинг',
      service6Desc:
        'Экспертное сопровождение цифровой трансформации, архитектуры систем и технологической стратегии.',
      service7Title: 'Цифровое меню',
      service7Desc:
        'Цифровые меню для ресторанов, кондитерских, барбершопов, салонов и записи на услуги: онлайн-заказ, WhatsApp, QR-код, расписание и пакеты.',
      service8Title: 'Городской транспорт в реальном времени',
      service8Desc:
        'Умные решения для мониторинга и визуализации городского транспорта в реальном времени с акцентом на мобильность, геолокацию и пользовательский опыт.',
      cta: 'Смотреть все услуги'
    },
    founder: {
      title: 'Познакомьтесь с основателем',
      name: 'William Sarti José',
      role: 'Основатель и software engineer',
      bio:
        'Более 10 лет в IT; специализация — Java, React и искусственный интеллект. Опыт преподавания информатики, senior-разработки и руководства сложными проектами.',
      bio2:
        'Солидное академическое и профессиональное образование позволяет сочетать глубокие технические знания со стратегическим видением и создавать решения, которые действительно меняют ситуацию клиентов.',
      expertiseTitle: 'Области экспертизы',
      expertise1: 'Java и Spring Framework',
      expertise2: 'React и frontend-разработка',
      expertise3: 'ИИ и машинное обучение',
      expertise4: 'Архитектура систем',
      expertise5: 'Управление проектами',
      expertise6: 'Преподавание и менторинг',
      authorityTitle: 'Профессиональное присутствие',
      linkedin: 'LinkedIn',
      lattes: 'Резюме Lattes',
      github: 'Репозиторий GitHub',
      professionalCourse: 'Профессиональный курс',
      location: 'Брага, Португалия'
    },
    contact: {
      title: 'Готовы изменить свой бизнес?',
      subtitle: 'Свяжитесь с нами и узнайте, как мы можем помочь вашей компании расти',
      formTitle: 'Отправить сообщение',
      nameLabel: 'Ваше имя',
      namePlaceholder: 'ФИО',
      emailLabel: 'Электронная почта',
      emailPlaceholder: 'you@email.com',
      phoneLabel: 'Телефон (необязательно)',
      phonePlaceholder: '+7 (000) 000-00-00',
      messageLabel: 'Сообщение',
      messagePlaceholder: 'Расскажите о вашем проекте…',
      submitButton: 'Отправить',
      whatsappTitle: 'Или напишите в WhatsApp',
      whatsappButton: 'Открыть WhatsApp',
      infoTitle: 'Контактная информация',
      phone: 'Телефон',
      email: 'Email',
      locationLabel: 'Местоположение',
      phonesTitle: 'Телефоны',
      locationsTitle: 'Локации',
      phoneBrazilLabel: 'Бразилия',
      phonePortugalLabel: 'Португалия',
      phoneBrazilDisplay: '+55 18 99787-4643',
      phonePortugalDisplay: '+351 924 963 314',
      locationBrazil: 'Сан-Паулу, Бразилия',
      locationPortugal: 'Брага, Португалия'
    },
    footer: {
      tagline: 'Превращаем идеи в отличные цифровые решения',
      servicesTitle: 'Услуги',
      companyTitle: 'Компания',
      contactTitle: 'Контакты',
      servicesList: {
        web: 'Веб-разработка',
        ecommerce: 'E-commerce',
        marketing: 'Digital-маркетинг',
        automation: 'Автоматизация',
        mobile: 'Мобильные приложения'
      },
      companyList: {
        about: 'О нас',
        methodology: 'Методология',
        founder: 'Основатель',
        contact: 'Контакты'
      },
      copyright: '© 2025 WSJ Digital Solutions. Все права защищены.',
      followTitle: 'Подписаться на WSJ',
      madeWith: 'Сделано с',
      location: 'в Браге, Португалия'
    }
  },

  ar: {
    nav: {
      about: 'من نحن',
      services: 'الخدمات',
      methodology: 'المنهجية',
      founder: 'المؤسس',
      contact: 'اتصل بنا'
    },
    hero: {
      title: 'حوّل عملك مع',
      titleHighlight: 'حلول رقمية متميزة',
      subtitle:
        'تطوير ويب احترافي، تسويق رقمي استراتيجي، وأتمتة ذكية للشركات التي تسعى إلى التميز ونتائج حقيقية.',
      cta: 'احجز عرضًا توضيحيًا',
      ctaSecondary: 'محادثة عبر واتساب'
    },
    about: {
      title: 'عن WSJ Digital Solutions',
      description:
        'بدأ كل شيء برؤية ويليام سارتي خوسيه: تحويل الأفكار إلى حلول رقمية عصرية وأنيقة تركز على نتائج حقيقية.',
      description2:
        'تطوّر WSJ Digital Solutions منصات الويب والأتمتة والتجارة الإلكترونية والأنظمة المخصصة والقوائم الرقمية الذكية وحلول قابلة للتوسع للشركات التي تريد النمو رقميًا.\n\nالنقطة في «WSJ.» ترمز إلى الاستمرارية والتطور والتوسع المستمر — علامة جاهزة لتحويل الأعمال عبر التكنولوجيا.',
      yearsTitle: 'سنوات الخبرة',
      clientsTitle: 'عملاء راضون',
      projectsTitle: 'مشاريع مُنجزة'
    },
    pyramid: {
      title: 'منهجيتنا: هرم النجاح الرقمي',
      subtitle: 'نهج منظم ومثبت لتحويل حضورك الرقمي إلى نتائج ملموسة',
      level1Title: 'موقع خاص بك',
      level1Subtitle: 'أساس احترافي',
      level1Point1: 'مواقع مؤسسية متميزة بتصميم عصري',
      level1Point2: 'صفحات هبوط عالية التحويل',
      level1Point3: 'تكاملات وأتمتة متقدمة',
      level1Point4: 'تجربة مستخدم محسّنة',
      level2Title: 'التسويق الرقمي',
      level2Subtitle: 'نمو استراتيجي',
      level2Point1: 'إدارة احترافية لوسائل التواصل',
      level2Point2: 'إنتاج فيديو ومحتوى مرئي',
      level2Point3: 'حملات إعلانية موجهة نحو العائد على الاستثمار',
      level2Point4: 'تحليل البيانات والتحسين المستمر',
      level3Title: 'خدمات تقنية المعلومات',
      level3Subtitle: 'الابتكار وقابلية التوسع',
      level3Point1: 'تطوير الويب وتطبيقات الجوال',
      level3Point2: 'تجارة إلكترونية كاملة وتكاملات',
      level3Point3: 'أتمتة العمليات والأنظمة',
      level3Point4: 'حلول مخصصة وقابلة للتوسع'
    },
    services: {
      title: 'خدماتنا',
      subtitle: 'حلول متكاملة لتحويل عملك رقمياً',
      service1Title: 'تطوير الويب',
      service1Desc:
        'مواقع مؤسسية وصفحات هبوط وبوابات احترافية بتصميم متميز وتقنية حديثة.',
      service2Title: 'التجارة الإلكترونية',
      service2Desc:
        'متاجر كاملة، تكامل مدفوعات، وإدارة آلية لتعظيم مبيعاتك عبر الإنترنت.',
      service3Title: 'التسويق الرقمي',
      service3Desc:
        'استراتيجيات تسويق متكاملة، إدارة وسائل التواصل، وحملات إعلانية تركز على النتائج.',
      service4Title: 'الأتمتة',
      service4Desc:
        'تحسين العمليات وتوفير الوقت وتقليل التكاليف بأتمتة ذكية وتكاملات مخصصة.',
      service5Title: 'تطبيقات الجوال',
      service5Desc:
        'تطبيقات أصلية وهجينة لنظامي iOS وAndroid بتصميم سلس وأداء ممتاز.',
      service6Title: 'استشارات تقنية',
      service6Desc:
        'إرشاد متخصص للتحول الرقمي، وهندسة الأنظمة، والاستراتيجيات التقنية.',
      service7Title: 'قائمة طعام رقمية',
      service7Desc:
        'قوائم رقمية للمطاعم والمخابز والحلاقة والصالونات وخدمات المواعيد، مع طلب أونلاين وواتساب ورمز QR والجداول والباقات.',
      service8Title: 'النقل الحضري في الوقت الفعلي',
      service8Desc:
        'حلول ذكية لمراقبة وعرض النقل الحضري في الوقت الفعلي مع التركيز على التنقل والموقع وتجربة المستخدم.',
      cta: 'استكشف جميع الخدمات'
    },
    founder: {
      title: 'تعرّف على المؤسس',
      name: 'William Sarti José',
      role: 'المؤسس ومهندس برمجيات',
      bio:
        'أكثر من 10 سنوات في تقنية المعلومات؛ تخصص في Java وReact والذكاء الاصطناعي. تشمل مسيرته التدريس، التطوير ككبير مهندسين، وقيادة مشاريع تقنية معقدة.',
      bio2:
        'بخلفية أكاديمية ومهنية قوية، يجمع ويليام المعرفة التقنية العميقة مع الرؤية الاستراتيجية لتقديم حلول تُحدث فرقاً حقيقياً للعملاء.',
      expertiseTitle: 'مجالات الخبرة',
      expertise1: 'Java وإطار Spring',
      expertise2: 'React وتطوير الواجهات',
      expertise3: 'الذكاء الاصطناعي وتعلم الآلة',
      expertise4: 'هندسة الأنظمة',
      expertise5: 'إدارة المشاريع',
      expertise6: 'التدريس والإرشاد',
      authorityTitle: 'الحضور المهني',
      linkedin: 'LinkedIn',
      lattes: 'سيرة Lattes',
      github: 'مستودع GitHub',
      professionalCourse: 'دورة مهنية',
      location: 'براغا، البرتغال'
    },
    contact: {
      title: 'هل أنت مستعد لتحويل عملك؟',
      subtitle: 'تواصل معنا واكتشف كيف نساعد شركتك على التقدم',
      formTitle: 'أرسل رسالتك',
      nameLabel: 'اسمك',
      namePlaceholder: 'الاسم الكامل',
      emailLabel: 'البريد الإلكتروني',
      emailPlaceholder: 'your@email.com',
      phoneLabel: 'الهاتف (اختياري)',
      phonePlaceholder: '+966 00 000 0000',
      messageLabel: 'الرسالة',
      messagePlaceholder: 'أخبرنا عن مشروعك…',
      submitButton: 'إرسال الرسالة',
      whatsappTitle: 'أو راسلنا مباشرة عبر واتساب',
      whatsappButton: 'فتح واتساب',
      infoTitle: 'معلومات الاتصال',
      phone: 'الهاتف',
      email: 'البريد',
      locationLabel: 'الموقع',
      phonesTitle: 'أرقام الهاتف',
      locationsTitle: 'المواقع',
      phoneBrazilLabel: 'البرازيل',
      phonePortugalLabel: 'البرتغال',
      phoneBrazilDisplay: '+55 18 99787-4643',
      phonePortugalDisplay: '+351 924 963 314',
      locationBrazil: 'ساو باولو، البرازيل',
      locationPortugal: 'براغا، البرتغال'
    },
    footer: {
      tagline: 'تحويل الأفكار إلى حلول رقمية ممتازة',
      servicesTitle: 'الخدمات',
      companyTitle: 'الشركة',
      contactTitle: 'اتصل بنا',
      servicesList: {
        web: 'تطوير الويب',
        ecommerce: 'التجارة الإلكترونية',
        marketing: 'التسويق الرقمي',
        automation: 'الأتمتة',
        mobile: 'تطبيقات الجوال'
      },
      companyList: {
        about: 'من نحن',
        methodology: 'المنهجية',
        founder: 'المؤسس',
        contact: 'اتصل بنا'
      },
      copyright: '© 2025 WSJ Digital Solutions. جميع الحقوق محفوظة.',
      followTitle: 'تابع WSJ',
      madeWith: 'صُنع بـ',
      location: 'في براغا، البرتغال'
    }
  },

  'zh-CN': {
    nav: {
      about: '关于',
      services: '服务',
      methodology: '方法论',
      founder: '创始人',
      contact: '联系'
    },
    hero: {
      title: '让企业转型，尽在',
      titleHighlight: '优质数字解决方案',
      subtitle: '专业网站开发、战略数字营销与智能自动化，助力企业追求卓越与可衡量的成果。',
      cta: '预约演示',
      ctaSecondary: 'WhatsApp 咨询'
    },
    about: {
      title: '关于 WSJ Digital Solutions',
      description:
        '一切始于 William Sarti José 的愿景：把想法变成现代、优雅、以真实成果为导向的数字方案。',
      description2:
        'WSJ Digital Solutions 打造 Web 平台、自动化、电商、定制系统、智能数字菜单与可扩展方案，服务希望在数字环境中成长的企业。\n\n“WSJ.” 中的圆点象征延续、进化与不断扩张——一个准备用技术改变商业的品牌。',
      yearsTitle: '年经验',
      clientsTitle: '满意客户',
      projectsTitle: '交付项目'
    },
    pyramid: {
      title: '我们的方法论：数字成功金字塔',
      subtitle: '以结构化、可验证的方式，将您的数字影响力转化为切实成果',
      level1Title: '自有网站',
      level1Subtitle: '专业基础',
      level1Point1: '现代设计的企业官网',
      level1Point2: '高转化落地页',
      level1Point3: '高级集成与自动化',
      level1Point4: '优化的用户体验',
      level2Title: '数字营销',
      level2Subtitle: '战略增长',
      level2Point1: '专业社交媒体运营',
      level2Point2: '视频与视觉内容制作',
      level2Point3: '以投资回报为导向的广告投放',
      level2Point4: '数据分析与持续优化',
      level3Title: 'IT 服务',
      level3Subtitle: '创新与可扩展',
      level3Point1: '网站与移动应用开发',
      level3Point2: '完整电商与系统集成',
      level3Point3: '流程与系统自动化',
      level3Point4: '定制化、可扩展方案'
    },
    services: {
      title: '我们的服务',
      subtitle: '助力企业数字化转型的完整方案',
      service1Title: '网站开发',
      service1Desc: '企业站、落地页与专业门户，兼具高端设计与前沿技术。',
      service2Title: '电子商务',
      service2Desc: '全功能网店、支付集成与自动化管理，提升线上销售。',
      service3Title: '数字营销',
      service3Desc: '整合营销策略、社媒运营与以结果为导向的广告投放。',
      service4Title: '自动化',
      service4Desc: '以智能自动化与定制集成优化流程、节省时间、降低成本。',
      service5Title: '移动应用',
      service5Desc: '面向 iOS 与 Android 的原生与混合应用，直观设计、性能出色。',
      service6Title: 'IT 咨询',
      service6Desc: '数字化转型、系统架构与技术战略的专业顾问服务。',
      service7Title: '数字菜单',
      service7Desc:
        '餐厅、烘焙、理发、美容与预约型业务的数字餐单，支持在线下单、WhatsApp、二维码、时段与套餐。',
      service8Title: '实时城市交通',
      service8Desc:
        '聚焦出行、定位与用户体验，为城市交通的实时监控与可视化提供智能方案。',
      cta: '查看全部服务'
    },
    founder: {
      title: '认识创始人',
      name: 'William Sarti José',
      role: '创始人 & 软件工程师',
      bio:
        'William 在信息技术领域拥有逾 10 年经验，专精 Java、React 与人工智能。其经历涵盖计算机教学、资深开发与复杂技术项目领导。',
      bio2:
        '扎实的学术与职业背景使他兼具深厚技术与商业视野，为客户提供真正有价值的方案。',
      expertiseTitle: '专业领域',
      expertise1: 'Java 与 Spring 框架',
      expertise2: 'React 与前端开发',
      expertise3: '人工智能与机器学习',
      expertise4: '系统架构',
      expertise5: '项目管理',
      expertise6: '教学与辅导',
      authorityTitle: '职业资料',
      linkedin: '领英',
      lattes: 'Lattes 简历',
      github: 'GitHub 仓库',
      professionalCourse: '专业课程',
      location: '葡萄牙布拉加'
    },
    contact: {
      title: '准备好升级您的业务了吗？',
      subtitle: '联系我们，了解如何助力企业再上新台阶',
      formTitle: '发送留言',
      nameLabel: '姓名',
      namePlaceholder: '请输入全名',
      emailLabel: '电子邮箱',
      emailPlaceholder: 'your@email.com',
      phoneLabel: '电话（选填）',
      phonePlaceholder: '+86 000 0000 0000',
      messageLabel: '留言',
      messagePlaceholder: '请描述您的项目…',
      submitButton: '发送',
      whatsappTitle: '或直接通过 WhatsApp',
      whatsappButton: '打开 WhatsApp',
      infoTitle: '联系信息',
      phone: '电话',
      email: '邮箱',
      locationLabel: '地点',
      phonesTitle: '电话',
      locationsTitle: '办公地点',
      phoneBrazilLabel: '巴西',
      phonePortugalLabel: '葡萄牙',
      phoneBrazilDisplay: '+55 18 99787-4643',
      phonePortugalDisplay: '+351 924 963 314',
      locationBrazil: '巴西圣保罗',
      locationPortugal: '葡萄牙布拉加'
    },
    footer: {
      tagline: '将创意转化为卓越的数字方案',
      servicesTitle: '服务',
      companyTitle: '公司',
      contactTitle: '联系',
      servicesList: {
        web: '网站开发',
        ecommerce: '电子商务',
        marketing: '数字营销',
        automation: '自动化',
        mobile: '移动应用'
      },
      companyList: {
        about: '关于我们',
        methodology: '方法论',
        founder: '创始人',
        contact: '联系'
      },
      copyright: '© 2025 WSJ Digital Solutions。保留所有权利。',
      followTitle: '关注 WSJ',
      madeWith: '使用',
      location: '葡萄牙布拉加'
    }
  },

  'zh-TW': {
    nav: {
      about: '關於',
      services: '服務',
      methodology: '方法論',
      founder: '創辦人',
      contact: '聯絡'
    },
    hero: {
      title: '讓企業轉型，盡在',
      titleHighlight: '優質數位解決方案',
      subtitle: '專業網站開發、策略數位行銷與智慧自動化，協助企業追求卓越與可衡量的成果。',
      cta: '預約演示',
      ctaSecondary: 'WhatsApp 洽詢'
    },
    about: {
      title: '關於 WSJ Digital Solutions',
      description:
        '一切始於 William Sarti José 的願景：把想法化為現代、優雅、以真實成果為導向的數位方案。',
      description2:
        'WSJ Digital Solutions 打造 Web 平台、自動化、電商、客製系統、智慧數位菜單與可擴展方案，協助企業在數位環境中成長。\n\n「WSJ.」中的句點象徵延續、演進與不斷擴張——準備以科技改變商業的品牌。',
      yearsTitle: '年經驗',
      clientsTitle: '滿意客戶',
      projectsTitle: '交付專案'
    },
    pyramid: {
      title: '我們的方法論：數位成功金字塔',
      subtitle: '以結構化、可驗證的方式，將您的數位影響力轉化為具體成果',
      level1Title: '自有網站',
      level1Subtitle: '專業基礎',
      level1Point1: '現代設計的企業官網',
      level1Point2: '高轉換落地頁',
      level1Point3: '進階整合與自動化',
      level1Point4: '優化的使用者體驗',
      level2Title: '數位行銷',
      level2Subtitle: '策略成長',
      level2Point1: '專業社群媒體經營',
      level2Point2: '影片與視覺內容製作',
      level2Point3: '以投資報酬為導向的廣告投放',
      level2Point4: '資料分析與持續優化',
      level3Title: 'IT 服務',
      level3Subtitle: '創新與可擴展',
      level3Point1: '網站與行動應用開發',
      level3Point2: '完整電商與系統整合',
      level3Point3: '流程與系統自動化',
      level3Point4: '客製化、可擴展方案'
    },
    services: {
      title: '我們的服務',
      subtitle: '協助企業數位轉型的完整方案',
      service1Title: '網站開發',
      service1Desc: '企業站、落地頁與專業入口，兼具高階設計與前沿技術。',
      service2Title: '電子商務',
      service2Desc: '全功能網路商店、金流整合與自動化管理，提升線上銷售。',
      service3Title: '數位行銷',
      service3Desc: '整合行銷策略、社群經營與以結果為導向的廣告投放。',
      service4Title: '自動化',
      service4Desc: '以智慧自動化與客製整合優化流程、節省成本。',
      service5Title: '行動應用',
      service5Desc: '面向 iOS 與 Android 的原生與混合應用，直覺設計、效能出色。',
      service6Title: 'IT 顧問',
      service6Desc: '數位轉型、系統架構與技術策略的專業諮詢。',
      service7Title: '數位菜單',
      service7Desc:
        '餐廳、烘焙、理髮、美容與預約型服務的數位菜單，支援線上下單、WhatsApp、QR Code、時段與方案。',
      service8Title: '即時城市交通',
      service8Desc:
        '聚焦移動、定位與使用者體驗，為都市交通的即時監控與視覺化提供智慧方案。',
      cta: '查看全部服務'
    },
    founder: {
      title: '認識創辦人',
      name: 'William Sarti José',
      role: '創辦人暨軟體工程師',
      bio:
        'William 在資訊科技領域擁有逾 10 年經驗，專精 Java、React 與人工智慧。經歷涵蓋電腦教學、資深開發與複雜技術專案領導。',
      bio2:
        '扎實的學術與職涯背景使他兼具深厚技術與商業視野，為客戶創造真正價值。',
      expertiseTitle: '專業領域',
      expertise1: 'Java 與 Spring 框架',
      expertise2: 'React 與前端開發',
      expertise3: '人工智慧與機器學習',
      expertise4: '系統架構',
      expertise5: '專案管理',
      expertise6: '教學與指導',
      authorityTitle: '職涯資料',
      linkedin: 'LinkedIn',
      lattes: 'Lattes 履歷',
      github: 'GitHub 儲存庫',
      professionalCourse: '專業課程',
      location: '葡萄牙布拉加'
    },
    contact: {
      title: '準備好升級您的業務了嗎？',
      subtitle: '與我們聯絡，了解如何協助企業更上一層樓',
      formTitle: '傳送訊息',
      nameLabel: '姓名',
      namePlaceholder: '請輸入全名',
      emailLabel: '電子郵件',
      emailPlaceholder: 'your@email.com',
      phoneLabel: '電話（選填）',
      phonePlaceholder: '+886 000 000 000',
      messageLabel: '訊息',
      messagePlaceholder: '請描述您的專案…',
      submitButton: '送出',
      whatsappTitle: '或直接透過 WhatsApp',
      whatsappButton: '開啟 WhatsApp',
      infoTitle: '聯絡資訊',
      phone: '電話',
      email: '信箱',
      locationLabel: '地點',
      phonesTitle: '電話',
      locationsTitle: '據點',
      phoneBrazilLabel: '巴西',
      phonePortugalLabel: '葡萄牙',
      phoneBrazilDisplay: '+55 18 99787-4643',
      phonePortugalDisplay: '+351 924 963 314',
      locationBrazil: '巴西聖保羅',
      locationPortugal: '葡萄牙布拉加'
    },
    footer: {
      tagline: '將創意轉化為卓越的數位方案',
      servicesTitle: '服務',
      companyTitle: '公司',
      contactTitle: '聯絡',
      servicesList: {
        web: '網站開發',
        ecommerce: '電子商務',
        marketing: '數位行銷',
        automation: '自動化',
        mobile: '行動應用'
      },
      companyList: {
        about: '關於我們',
        methodology: '方法論',
        founder: '創辦人',
        contact: '聯絡'
      },
      copyright: '© 2025 WSJ Digital Solutions。版權所有。',
      followTitle: '關注 WSJ',
      madeWith: '使用',
      location: '葡萄牙布拉加'
    }
  }
};
